import { DropdownItem, LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutInactiveCarrierReport } from "./autogen/AutogenLayoutInactiveCarrierReport";

export class InactiveCarrierReport extends AutogenLayoutInactiveCarrierReport {
    override onLoad(): void {
        this.textboxGroupBy.items = [
            new DropdownItem("N", "None"),
            new DropdownItem("M", "Carrier Manager"),
            new DropdownItem("C", "Carrier Category"),
            new DropdownItem("S", "Salesperson")
        ];

        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
    }

    afterGroupBySelection() {
        if (this.textboxGroupBy.selectedItem?.value === "N") {
            this.checkboxPageBreak.enabled = false;
            this.checkboxPageBreak.checked = false;
            return;
        }
        this.checkboxPageBreak.enabled = true;
    }

    beforeCategorySearch(event: LookupModelSearchEvent) {
        event.filter.carrier = "Y";
    }

    beforeManagerSearch(event: LookupModelSearchEvent) {
        event.filter.web_user_type = ("E || U");
    }
}
